module.exports = new __parcel__URL__("the-legend-of-zelda-breath-of-the-wild.0f1758f7.jpg").toString();